<div *ngIf="item && item.cells" class="container flex flex-row justify-between items-center">

  <div class="grid-cell-ellipsis"
       matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}">
    <a (click)="onClicked('itemClick')" class="flex flex-row justify-start items-center"
       particleAnalytics
       analyticsCategory="link-cell-viewer"
       [ngClass]="!item.isReadOnly || fieldDefinition?.metaData?.CanCellUnlock === 'true' ? 'link-color' : 'disabled'"
       [analyticsAction]="item.cells[fieldDefinition.key]?.displayText"
    > {{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}
    </a>
  </div>

  <button *ngIf="!item.isReadOnly" (click)="onClicked('Edit')" mat-icon-button class="icon-dropdown-button">
    <mat-icon>create</mat-icon>
  </button>
</div>

